export * from "./textures.webMapTexture";
export * from "./texture.texture3";
export * from "./texture.map";
//# sourceMappingURL=index.js.map